module.exports = __webpack_public_path__ + "static/poly-self-portrait-dadb6666af40b3a8e47dfdfe2e594c0d.png";